'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import type { ModalState } from '@/app/components/sections/register/modals/types';
export const useModalStateResult = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      isSuccess: false,
      isError: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [modalState, setModalState] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setModalState({
        isSuccess: true,
        isError: false
      });
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSuccess = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setModalState({
        isSuccess: false,
        isError: true
      });
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleError = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setModalState({
        isSuccess: false,
        isError: false
      });
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onClose = t3;
  let t4;
  if ($[4] !== modalState) {
    t4 = {
      modalState,
      handleSuccess,
      handleError,
      onClose
    };
    $[4] = modalState;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};